module.exports = __webpack_public_path__ + "img/tree_right_layout_icon.b8971028.svg";